import { grpc } from '@improbable-eng/grpc-web'
import { NodeHttpTransport } from '@improbable-eng/grpc-web-node-http-transport'
import { commonMetaData } from '~/store/_helpers/common-helper'

// initial state
export const state = () => ({
  ServiceIndicator: {},
  indicatorsMap: [],
  ratingCommentsList: [],
  page: null,
  perPage: null
})

// getters
export const getters = {}

// actions
export const actions = {
  async serviceRagingsRequests({ rootState }, { params }) {
    const [{ GetServiceRatingsRequest }, { ServiceService }] = await Promise.all([
      import('~/stub/apigateway/service/service_pb'),
      import('~/stub/apigateway/service/service_pb_service')
    ])
    const getRequest = new GetServiceRatingsRequest()
    const setMetadata = commonMetaData(rootState)
    const toNumber = value => {
      return typeof value === 'undefined' ? value : Number(value)
    }
    getRequest.setServiceId(toNumber(params.id))

    const serviceServiceRatingsReply = await new Promise((resolve, reject) => {
      grpc.invoke(ServiceService.GetServiceRatings, {
        request: getRequest,
        metadata: setMetadata,
        host: process.env.config.grpcWebUrl,
        transport: NodeHttpTransport(),
        onMessage: message => {
          resolve(message.toObject())
        },
        onEnd: (grpcCode, message, trailers) => {
          if (grpcCode !== grpc.Code.OK) {
            reject({ grpcCode })
          }
        }
      })
    })

    return serviceServiceRatingsReply
  },
  async getMoreRatings({ commit, rootState }, { params, query, page }) {
    const [{ GetServiceRatingsRequest }, { ServiceService }] = await Promise.all([
      import('~/stub/apigateway/service/service_pb'),
      import('~/stub/apigateway/service/service_pb_service')
    ])
    const getRequest = new GetServiceRatingsRequest()
    const setMetadata = commonMetaData(rootState)
    const toNumber = value => {
      return typeof value === 'undefined' ? value : Number(value)
    }
    getRequest.setServiceId(toNumber(params.id))
    getRequest.setPage(toNumber(page))

    const getMoreRatingsReply = await new Promise((resolve, reject) => {
      grpc.invoke(ServiceService.GetServiceRatings, {
        request: getRequest,
        metadata: setMetadata,
        host: process.env.config.grpcWebUrl,
        transport: NodeHttpTransport(),
        onMessage: message => {
          resolve(message.toObject())
        },
        onEnd: (grpcCode, message, trailers) => {
          if (grpcCode !== grpc.Code.OK) {
            reject({ grpcCode })
          }
        }
      })
    })

    commit('RECEIVE_MORE_RATINGS', {
      getMoreRatingsReply
    })
  }
}

// mutations
export const mutations = {
  RECEIVE(state, data) {
    Object.assign(state, data)
  },
  RECEIVE_MORE_RATINGS(state, data) {
    state.page = data.getMoreRatingsReply.page
    state.ratingCommentsList = state.ratingCommentsList.concat(
      data.getMoreRatingsReply.ratingCommentsList
    )
  }
}
